import MapIcon from "@heroicons/react/24/solid/MapIcon";
import { styled as styling } from "@mui/material/styles";
import Color from "../../../assets/colors";

export const AddressSectionCard = styling("div")({
  width: "100%",
  padding: "2rem",
  background: Color.white,
  borderRadius: "0.75rem",
  outline: "1px solid #E8E8E8",
  outlineOffset: "-1px",

  "@media (max-width: 640px)": {
    padding: "1.25rem 1rem",
  },
});

export const MapContainer = styling("iframe")({
  borderRadius: "1rem",
  border: `1px solid ${Color.grey}`,

  height: "272px",

  "@media (max-width: 640px)": {
    height: "242px",
  },
});

export const AddressIcon = styling(MapIcon)({
  width: "1.5rem",
  height: "1.5rem",
});
